import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-verify-email-success',
  templateUrl: './verify-email-success.component.html',
  styleUrls: ['./verify-email-success.component.scss']
})
export class VerifyEmailSuccessComponent implements OnInit {

  constructor(
    private navigationService: NavigationService
  ) { }

  ngOnInit(): void {
  }

  navigateToHome() {
    this.navigationService.navigate(["home"]);
  }

}
